module.exports = __webpack_public_path__ + "img/icons BFr_37.59034293.png";